import epicTracking from 'epic-tracking';

export const triggerAnalytic = (section: string): void => {
  epicTracking.trackEvent('Interaction', {
    interactionType: 'scrollViewSection',
    eventCategory: `Subscription ${section} section`,
    eventAction: `${section}Section-inView`,
  });
};
